export default __webpack_public_path__ + "static/media/warning.f984287a.webp";